import { jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { memo } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleRightSmallOutlined as C } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-right-small-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { IconButton } from "../../icon-button/icon-button.es.js";
import { PRIMARY_COLOR } from "../../../foundations/constants.es.js";
function ProductCardActionBuilder({
  iconButtonId,
  disabled = false,
  isMobile
}) {
  if (isMobile) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx("div", { "data-testid": "card-container-boundary-margin-left", children: /* @__PURE__ */ jsx(IconButton, { id: iconButtonId ?? "product-card-action-icon", color: PRIMARY_COLOR, size: "large", disabled, children: /* @__PURE__ */ jsx(C, {}) }) });
}
const ProductCardAction = memo(ProductCardActionBuilder);
export {
  ProductCardAction
};
//# sourceMappingURL=product-card-action.es.js.map
